import React from 'react';
import styles from '../header.module.scss';

const HeaderArrow = () => (
    <svg
        className="snv-caret"
        viewBox="0 0 12 12"
        width="6"
        height="6"
        fill="none"
        aria-hidden="true"
    >
        <path
            d="M2.5 4.5 6 8l3.5-3.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={styles.headerArrow}
        ></path>
    </svg>
);
export default HeaderArrow;
